import React from "react";
import DataTable from "../../table/DataTable";

const RateTab = () => {
  const rateData = [
    { send: "USD", receive: "VND", rate: "24,850" },
    { send: "USD", receive: "EUR", rate: "0.93" },
    { send: "USD", receive: "GBP", rate: "0.81" },
    { send: "EUR", receive: "USD", rate: "1.08" },
    { send: "GBP", receive: "USD", rate: "1.23" },
  ];

  const rateColumns = [
    { label: "Send currency", key: "send", className: "ps-4" },
    { label: "Receive currency", key: "receive", className: "ps-2 fw-bold" },
    { label: "Final rate", key: "rate", className: "ps-2 fw-bold" },
  ];

  return (
    <DataTable
      data={rateData}
      columns={rateColumns}
      showPagination={false}
      minWidth="100%"
    />
  );
};

export default RateTab;
